/**
 * Helpers for auth.kronos.login workflow context outputs.
 */

/**
 * @param {object|null|undefined} authUser
 * @returns {string|null}
 */
export const resolveAuthKronosUserId = (authUser) => {
    if (!authUser)
        return null;
    const id = authUser.id ?? authUser._id;
    return id != null && String(id).trim() !== '' ? String(id) : null;
};

/**
 * Build auth context keys written by auth.kronos.login.
 * `registered` and `loggedin` are mutually exclusive path flags.
 *
 * @param {object} authUser
 * @param {{ fromRegister?: boolean, fromLogin?: boolean }} [path]
 * @returns {{ user: object, user_id: string|null, registered: boolean, loggedin: boolean }}
 */
export const buildAuthKronosLoginContextPatch = (authUser, path = {}) => {
    const user_id = resolveAuthKronosUserId(authUser);
    const fromRegister = !!path.fromRegister;
    return {
        user: authUser,
        user_id,
        registered: fromRegister,
        loggedin: !fromRegister,
    };
};
